import { faArrowDownToBracket } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './styles.scss';
import { Button } from '@mui/material';

interface DownloadButtonProps {
  onClick: () => void;
  label?: string;
  icon?: JSX.Element;
  disabled?: boolean;
}

export const DownloadButton = ({
  onClick,
  label = 'Download',
  icon,
  disabled,
}: DownloadButtonProps) => {
  return (
    <Button className="download-button" onClick={onClick} disabled={disabled}>
      {icon ?? <FontAwesomeIcon icon={faArrowDownToBracket} />}
      <span>{label}</span>
    </Button>
  );
};
